import UserFetch from '../fetch/user';
import {
  getKeysTotal,
  randomLetNum,
  getAllMembers,
  getQueryString,
  formateMonth,
  currHost,
} from '../utils/utils.js';
import router from '../router/router';
import Auth from '../utils/auth';
import Container from '../utils/container.js';
import { Toast } from 'mint-ui';
import { userWebService }  from '@/utils/webService';
const webService = userWebService;
//const webService = new UserFetch();

const actions = {
  handleErrorMessage({ commit }, err) {
    commit('handleErrorMessage', err);
  },
  handleSuccessMessage({ commit }, suc) {
    commit('handleSuccessMessage', suc);
  },

  // 合并用户信息请求
  init({ commit }) {
    Promise.all([
      webService.getUserInfo(),
      webService.getUserScore(),
      webService.getProfit(),
      webService.getNexus(),
      //webService.getChannelList(),
      webService.getUserProfit(),
      webService.getOwnRank('week'),
      webService.getMemberLevelList(),
    ])
      .then(response => {
        commit('setUserInfo', response[0].data.user);
        let idolInfo = response[0].data.users.find(
          s => s.id === response[0].data.user.idolUserId
        );
        commit('setIdolInfo', idolInfo);
        commit('setScore', {
          ...response[1].data,
          total:
            (response[1].data.indirect || 0) + (response[1].data.direct || 0),
        });
        commit('setProfit', {
          ...response[2].data,
          total: (response[2].data.retail || 0) + (response[2].data.team || 0),
        });
        commit('setNexus', {
          ...response[3].data,
          total: getAllMembers(response[3].data),
        }); //TODO 这里谁处理一下，不能写到 utils里去。
        //commit('setChannel', { ...response[4].data, list: response[4].data.list.map(s => ({ ...s, edit: false })) });
        commit('setUserProfit', response[4].data.surplus);
        commit('setOwnRank', response[5].data);
        commit('MEMBER_LEVEL_LIST', response[6].data);
      })
      .catch(err => {
        commit('handleErrorMessage', err);
      });

    Promise.all([webService.getChannelList()])
      .then(response => {
        let data = response[0].data;
        commit('setChannel', {
          ...data,
          list: data.list.map(s => ({ ...s, edit: false })),
        });
      })
      .catch(err => {
        commit('handleErrorMessage', err);
      });
  },
  // 总战绩
  getProfit({ commit }) {
    webService
      .getProfit()
      .then(response =>
        commit('setProfit', {
          ...response.data,
          total: (response.data.retail || 0) + (response.data.team || 0),
        })
      )
      .catch(err => {
        commit('handleErrorMessage', err);
      });
  },

  // 获取用户战绩
  getChannelList({ commit }) {
    webService
      .getChannelList()
      .then(response =>
        commit('setChannel', {
          ...response.data,
          list: response.data.list.map(s => ({ ...s, edit: false })),
        })
      )
      .catch(err => {
        commit('handleErrorMessage', err);
      });
  },

  // 获取用户排名getOwnRank
  getOwnRank({ commit }, rankBy) {
    webService
      .getOwnRank(rankBy)
      .then(response => commit('setOwnRank', response.data))
      .catch(err => {
        commit('handleErrorMessage', err);
      });
  },
  // 获取用户金额
  getUserProFit({ commit }) {
    webService
      .getUserProfit()
      .then(response => commit('setUserProfit', response.data.surplus))
      .catch(err => {
        commit('handleErrorMessage', err);
      });
  },
  // 修改用户名
  editUserName({ commit }, e) {
    commit('setUserName', e.target.value);
  },
  // 修改个性签名
  editSign({ commit }, e) {
    commit('editSign', e.target.value);
  },
  // 上传微信二维码
  uploadWxCode({ commit }, e) {
    const formData = new FormData();
    formData.append('name', e.target.files[0].name);
    formData.append('type', e.target.files[0].type.split('/')[1]);
    formData.append('file', e.target.files[0]);
    webService
      .upLoadTemp(formData)
      .then(response => {
        webService
          .guess({
            tempKey: response.data.tempKey,
            guess: 'wxFirendCard',
          })
          .then(response => {
            if (response.data.right) {
              commit('setWxCode', response.data.newQrcode);
            } else {
              commit('handleErrorMessage', '您上传的不是名片二维码 请重新上传');
            }
          })
          .catch(err => {
            commit('handleErrorMessage', err);
          });
      })
      // webService.upLoadFile(formData)
      // .then((response, error) => commit('setWxCode', `${response.data.host}/${response.data.path}`))
      .catch(err => {
        commit('handleErrorMessage', err);
      });
  },

  // 获取用户信息
  getUserInfo({ commit }) {
    webService.getUserInfo().then(response => {
      commit('setUserInfo', response.data.user);
      let idolInfo = response.data.users.find(
        s => s.id === response.data.user.idolUserId
      );
      commit('setIdolInfo', idolInfo);
    });
  },

  // 到自己的openid
  getOpenid({ commit }) {
    webService
      .getOpenid()
      .then(response => commit('setOpenid', response.data.openid));
  },
  //获取站点接口版本信息
  getSiteVersion({ commit }) {
    webService
      .getSiteVersion()
      .then(response => commit('setSiteVersion', response.data.version));
  },
  // 到自己的openid
  getPasswd({ commit }) {
    webService
      .getPasswd()
      .then(response => commit('setPasswd', response.data.passwd));
  },
  // 保存用户信息
  editUserInfo({ commit, dispatch }, userInfo) {
    console.log('userInfo=' + JSON.stringify(userInfo));

    if (userInfo.nick && userInfo.nick.trim() === '') {
      commit('handleErrorMessage', '昵称不能为空！');
      return;
    }

    if (userInfo.wxQrcodeCardUrl !== null) {
      webService
        .editUserInfo({
          nick: userInfo.nick,
          sign: userInfo.sign,
          headUrl: userInfo.headUrl || undefined,
          wxQrcodeCardUrl: userInfo.wxQrcodeCardUrl || undefined,
        })
        .then(response => {
          commit('handleSuccessMessage', response.data.msg);
          setTimeout(() => {
            router.push('/user/detail');
          }, 1000);
        })
        .catch(err => {
          commit('handleErrorMessage', err);
          dispatch('getUserInfo');
        });
    } else {
      webService
        .editUserInfo({
          nick: userInfo.nick,
          sign: userInfo.sign,
          headUrl: userInfo.headUrl,
          // wxQrcodeCardUrl: userInfo.wxQrcodeCardUrl
        })
        .then(response => {
          commit('handleSuccessMessage', response.data.msg);
          setTimeout(() => {
            router.push('/user/detail');
          }, 1000);
        })
        .catch(err => {
          commit('handleErrorMessage', err);
          dispatch('getUserInfo');
        });
    }
  },
  // 查询自己的所有零售佣金
  getIncomeRetail({ commit }) {
    Promise.all([
      webService.getIncomeRetail(),
      webService.getTotalIncomeRetail(),
    ])
      .then(response => {
        commit('setIncomeRetail', {
          list: response[0].data.list.map(s => {
            const user = response[0].data.users.find(
              item => item.id === s.payUserId
            );
            return { ...s, user };
          }),
        });
        commit('setTotalIncomeRetail', response[1].data.sum);
      })
      .catch(err => {
        commit('handleErrorMessage', err);
      });
  },
  // 查询自己的团队佣金记录
  getIncomeTeam({ commit }) {
    Promise.all([webService.getIncomeTeam(), webService.getTotalIncomeTeam()])
      .then(response => {
        commit('setIncomeTeam', {
          list: response[0].data.list.map(s => {
            const user = response[0].data.users.find(
              item => item.id === s.payUserId
            );
            return { ...s, user };
          }),
        });
        commit('setTotalIncomeTeam', response[1].data.sum);
      })
      .catch(err => {
        commit('handleErrorMessage', err);
      });
  },
  // 获取提现记录
  getWithDrawList({ commit }) {
    webService
      .getWithDrawList()
      .then(response => commit('setWithDrawList', response.data.list))
      .catch(err => {
        commit('handleErrorMessage', err);
        commit('setWithDrawList', []);
      });
  },
  // 查询自己的零售层级概述
  getNexusRetailLevel({ commit }) {
    webService
      .getNexusRetailLevel(3)
      .then(response => commit('setNexusRetailLevel', response.data))
      .catch(err => {
        commit('handleErrorMessage', err);
        commit('setNexusRetailLevel', { overview: [], users: [] });
      });
  },
  // 查询自己的团队层级概述
  getNexusTeamLevel({ commit }) {
    webService
      .getNexusTeamLevel(3)
      .then(response => commit('setNexusTeamLevel', response.data))
      .catch(err => {
        commit('handleErrorMessage', err);
        commit('setNexusTeamLevel', { overview: [], users: [] });
      });
  },
  // 查询自己的粉丝列表
  getFansList({ commit }) {
    webService
      .getFansList()
      .then(response => {
        commit('setFansList', {
          ...response.data,
          fans: response.data.fans.map(item => {
            const user = response.data.users.find(
              user => user.id === item.fansUserId
            );
            return { ...item, user };
          }),
        });
      })
      .catch(err => {
        //          commit('handleErrorMessage', err);
        commit('setFansList', { fans: [], users: [] });
      });
    // TODO 成功提醒
  },
  // 查询实时佣金排名top /profit/top/realtime
  getProfitRealTime({ commit, dispatch }, rankBy) {
    dispatch('getOwnRank', rankBy);
    webService
      .getProfitRealTime(rankBy)
      .then(response => commit('setTopProfit', response.data))
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  // 列出提现收款二维码getProfitAcceptQrcode
  getProfitAcceptQrcode({ commit }) {
    webService
      .getProfitAcceptQrcode()
      .then(response => commit('setQrocodes', response.data.qrocodes))
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  // 上传微信收款二维码
  uploadWxQrcodeCode({ commit }, e, status) {
    const formData = new FormData();
    formData.append('name', e.target.files[0].name);
    formData.append('type', e.target.files[0].type.split('/')[1]);
    formData.append('file', e.target.files[0]);
    webService
      .upLoadTemp(formData)
      .then(response => {
        webService
          .guess({
            tempKey: response.data.tempKey,
            guess: 'wxpay',
          })
          .then(response => {
            if (response.data.right) {
              if (status) {
                webService
                  .addWxAcceptQrcode(response.data.newQrcode)
                  .then(response => {
                    commit('setWxQrocode', response.data.qrcode);
                    commit('handleSuccessMessage', '添加成功！');
                  });
              } else {
                webService
                  .changeWxAcceptQrcode(response.data.newQrcode)
                  .then(response => {
                    commit('setWxQrocode', response.data.qrcode);
                    commit('handleSuccessMessage', '修改成功！');
                  });
              }
            } else {
              commit('handleErrorMessage', '只能添加微信收款码，请重新选择');
            }
          })
          .catch(err => {
            //              commit('handleErrorMessage', err);
          });
      })
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  // 上传支付宝收款二维码
  uploadAlipayQrcodeCode({ commit }, e) {
    const formData = new FormData();
    formData.append('name', e.target.files[0].name);
    formData.append('type', e.target.files[0].type.split('/')[1]);
    formData.append('file', e.target.files[0]);
    webService
      .upLoadTemp(formData)
      .then(response => {
        webService
          .guess({
            tempKey: response.data.tempKey,
            guess: 'alipay',
          })
          .then(response => {
            if (response.data.right) {
              if (status) {
                webService
                  .addAlipayAcceptQrcode(response.data.newQrcode)
                  .then(response => {
                    commit('setAlipayQrocode', response.data.qrcode);
                    commit('handleSuccessMessage', '添加成功！');
                  });
              } else {
                webService
                  .changeAlipayAcceptQrcode(response.data.newQrcode)
                  .then(response => {
                    commit('setAlipayQrocode', response.data.qrcode);
                    commit('handleSuccessMessage', '修改成功！');
                  });
              }
            } else {
              commit('handleErrorMessage', '只能添加支付宝收款码，请重新选择');
            }
          })
          .catch(err => {
            //              commit('handleErrorMessage', err);
          });
      })
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  // 提现profitTakeApply
  profitTakeApply({ commit, dispatch }, withDrawValue) {
    webService
      .profitTakeApply(withDrawValue)
      .then(response => {
        commit('handleSuccessMessage', '申请已提交');
        dispatch('getUserProFit');
        dispatch('getWithDrawList');
        setTimeout(() => {
          router.push(
            `/user/confirmWithDraw?withDrawId=${response.data.recordId}`
          );
        }, 2000);
      })
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  // 上传用户头像
  uploadUserAvatar({ commit }, e) {
    const formData = new FormData();
    formData.append('name', e.target.files[0].name);
    formData.append('type', e.target.files[0].type.split('/')[1]);
    formData.append('file', e.target.files[0]);
    webService
      .upLoadFile(formData)
      .then(response =>
        commit('setUserAvatar', `${response.data.host}/${response.data.path}`)
      )
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  // 获取朋友圈推广海报
  getFriendEnvPoster({ commit }) {
    webService
      .getFriendEnvPoster()
      .then((response, error) =>
        commit('setFriendEnvPoster', response.data.posters)
      )
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  // 获取微信好友推广海报
  getFriendPoster({ commit }) {
    webService
      .getFriendPoster()
      .then((response, error) =>
        commit('setFriendPoster', response.data.posters)
      )
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  // 确认余额到账
  confirmWithDraw({ commit, dispatch }, recordId) {
    webService
      .confirmWithDraw(recordId)
      .then((response, error) => {
        commit('handleSuccessMessage', '操作成功');
        dispatch('getUserProFit');
        setTimeout(() => {
          router.replace(`/user/profit`);
        }, 2000);
      })
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  // 获取fans报表
  getFans({ commit }, type) {
    webService
      .getFans(type)
      .then((response, error) => {
        commit('setFans', response.data.list, formateMonth);
      })
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  // 获取fans总览
  getFansSummary({ commit }) {
    webService
      .getFansSummary()
      .then((response, error) => {
        const summary = {
          all: response.data.all.count,
          day: response.data.day.count,
          week: response.data.week.count,
          month: response.data.month.count,
        };
        commit('setFansSummary', summary);
      })
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  // 修改channel可编辑状态
  changeChannelEdit({ commit }, id) {
    commit('setChannelEdit', id);
  },
  // 失去焦点blur
  blur({ commit }) {
    commit('setBlur');
  },
  // 修改名字
  changeChannelName({ commit, dispatch }, data) {
    webService
      .changeChangeName(data)
      .then(response => {
        dispatch('getChannelList');
        commit('handleSuccessMessage', '修改成功！');
      })
      .catch(err => {
        dispatch('getChannelList');
        //          commit('handleErrorMessage', err);
      });
  },
  // 增加渠道
  addChannel({ commit, dispatch }) {
    webService
      .addChannel()
      .then(response => {
        dispatch('getChannelList');
        commit('handleSuccessMessage', '添加成功！');
      })
      .catch(err => {
        dispatch('getChannelList');
        //          commit('handleErrorMessage', err);
      });
  },
  //要登录需要login的准工作
  /*   loginInit({ commit }) {
        webService.getLoginConfig()
        .then(response => {
            commit('setLoginConfig', response.data);
        })
        .catch(err => {
          commit('handleErrorMessage', err);
        });
    },*/
  login({ commit }, data) {
    webService
      .login(data)
      .then(response => {
        if (response.data.result === false) {
          commit('handleErrorMessage', response.data.msg);
          commit('login', true);
          return;
        }
        Auth.saveToken(response.data.token);
        router.replace({
          name: 'login',
          params: { action: 'end' },
          query: { refer: data.refer || '/' },
        });
        //window.localStorage.setItem('token', response.data.token);
      })
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  getLoginCode({ commit }, data, callBack) {
    webService
      .getLoginCode(data)
      .then(response => {
        commit('setLoginCode', true);
      })
      .catch(err => {
        commit('setLoginCode', false);
        //          commit('handleErrorMessage', err);
      });
  },
  initLoginCode({ commit }) {
    commit('setLoginCode', false);
  },
  loginWithCode({ commit }, data) {
    webService
      .loginWithCode(data)
      .then(response => {
        Auth.saveToken(response.data.token);
        router.replace('/login/passwd?setPwd=true&code=' + data.code);
       // router.replace(data.refer || '/');
      })
      .catch(err => {
        commit('setLoginCode', false);
        //          commit('handleErrorMessage', err);
      });
  },
  bindPhone({ commit }, data) {
    webService
      .bindPhone(data)
      .then(response => {
        router.go(-1);
      })
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  uploadBase64({ commit }, data) {
    webService
      .uploadBase64(data)
      .then(response =>
        commit('setUserAvatar', `${response.data.host}/${response.data.path}`)
      )
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  setPassword({ commit }, data) {
    webService
      .setPassword(data)
      .then(response => {
        commit('handleSuccessMessage', '密码设置成功！');
        router.replace('/');
      })
      .catch(err => {
        //          commit('handleErrorMessage', err);
      });
  },
  initLogin({ commit }) {
    commit('login', false);
  },
  //复制成功提示
  onCopy({ commit }) {
    Toast('复制成功');
    commit('handleSuccessMessage', '复制成功！');
  },
  //复制失败提示
  onError({ commit }) {
    Toast('复制失败了');
    commit('handleErrorMessage', '复制失败了');
  },
  clearServerToken({ commit }) {
    webService.deleteOpenid().then(response => {
      commit('handleSuccessMessage', 'openid清除成功！');
    });
  },
  clearLocalToken({ commit }) {
    Auth.clearToken();
    Toast('token清除成功');
  },
  clearLocalClientId({ commit }) {
    Container.localRemove('clientId');
    Toast('clientId清除成功');
  },
  refreshPage({ commit }) {
    location.reload();
  },
  reportLocal({ commit, dispatch }, report) {
    webService
      .reportLocal(report)
      .then(response => {
        Toast('上传成功');
        commit('handleSuccessMessage', '上传成功！');
      })
      .catch(err => {
        Toast('err');
        //          commit('handleErrorMessage', err);
      });
  },
  cleanUserInfo({ commit }) {
    const clearLocal = () => {
      Auth.clearToken();
      Container.localRemove('clientId');
      window.location.replace('https://www.baidu.com');
      //window.close();
      //https://www.jianshu.com/p/9dc2752194b8
    };
    if (Auth.loginUser()) {
      webService.deleteOpenid().then(response => {
        clearLocal();
      });
    } else {
      clearLocal();
    }
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/actions/user.js